module.exports = __webpack_public_path__ + "img/1.146f9ebd.jpg";